import { format, getTime, formatDistanceToNow } from "date-fns";

// ----------------------------------------------------------------------

export function fDate(date) {
  return format(new Date(date), "MMMM dd yyyy");
}

export function fDateWithDay(date) {
  return format(new Date(date), "eeee, MMMM do yyyy");
}

export function fDateTime(date) {
  return format(new Date(date), "MMM dd yyyy HH:mm");
}
export function fDateShort(date) {
  return format(new Date(date), "MMM dd yyyy"); 
}

export function fTimestamp(date) {
  return getTime(new Date(date));
}

export function fDateTimeSuffix(date) {
  return format(new Date(date), "MMM dd yyyy h:mm a");
}

export function fToNow(date) {
  return formatDistanceToNow(new Date(date), {
    addSuffix: true,
  });
}

// Unwraps date values that were persisted as serialized moment objects
// ({ _isAMomentObject, _i, _d, ... }) back into their original date string.
export function normalizeDateValue(value) {
  if (value && typeof value === "object" && value._isAMomentObject) {
    return typeof value._i === "string" ? value._i : value._d;
  }
  return value;
}

export function isValidDateValue(value) {
  const normalized = normalizeDateValue(value);
  return !!normalized && !Number.isNaN(new Date(normalized).getTime());
}
